/** Manages subtask calculation and state for the task form. */
import { useMemo } from 'react';
import {
  getFormSubtasks,
  calculateIncompleteSubtasksDuration,
} from '@/features/tasks/utils/ui/taskFormUtils';

export const useTaskFormSubtasks = (initialTask, tasks) => {
  const subtasks = useMemo(
    () => getFormSubtasks(initialTask, tasks),
    [initialTask, tasks],
  );

  const incompleteSubtasks = useMemo(
    () => subtasks.filter((t) => !t.completed),
    [subtasks],
  );

  const calculatedDuration = useMemo(
    () => calculateIncompleteSubtasksDuration(subtasks),
    [subtasks],
  );

  const isRollup = subtasks.length > 0;

  return { subtasks, incompleteSubtasks, calculatedDuration, isRollup };
};
